import {
  GetStoreManagerHierarchyRequest,
  GetStoreManagerMapHierarchyRequest,
} from '@app/infrastructure/api/models';

// Temporary: the map saves its own location group until it replaces the list.
export type StoreManagerView = 'list' | 'map';

export class SetStoreManagerListConfig {
  static readonly type = '[Store Manager] Set List Config';
  constructor(
    public config: GetStoreManagerHierarchyRequest &
      Pick<GetStoreManagerMapHierarchyRequest, 'lowCoverageOnly'>,
    public view: StoreManagerView,
  ) {}
}

export class SaveStoreManagerViewState {
  static readonly type = '[Store Manager] Save View State';
  constructor(
    public expandedLocationId: string | undefined,
    public scrollPosition: number,
  ) {}
}

export class ResetStoreManagerViewState {
  static readonly type = '[Store Manager] Reset View State';
}
